module.exports = __webpack_public_path__ + "img/general-information.38d079b6.svg";